import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AttendanceApp from "./pages/attendance/App";
import AuditApp from "./pages/audit/AuditApp";
import NicobarApp from "./pages/nicobar/NicobarApp";
import AuditFirmDelhi from "./pages/seo/AuditFirmDelhi";
import StockAuditDelhi from "./pages/seo/StockAuditDelhi";
import InternalAuditDelhi from "./pages/seo/InternalAuditDelhi";
import FixedAssetVerificationDelhi from "./pages/seo/FixedAssetVerificationDelhi";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/attendance/*" element={<AttendanceApp />} />
          <Route path="/audit/*" element={<AuditApp />} />
          <Route path="/nicobar/*" element={<NicobarApp />} />
          {/* SEO Pages */}
          <Route path="/audit-firm-in-delhi" element={<AuditFirmDelhi />} />
          <Route path="/stock-audit-services-delhi" element={<StockAuditDelhi />} />
          <Route path="/internal-audit-services-delhi" element={<InternalAuditDelhi />} />
          <Route path="/fixed-asset-verification-delhi" element={<FixedAssetVerificationDelhi />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;